import HttpRequest from "../../Common/Http/HttpRequest";

export default class LoginService {

    async doLogin(username, password) {
        return HttpRequest.post('node/auth/autenticar', {email: username, password, rememberMe: true});
    }

    async recoveryPassword(username) {
        return HttpRequest.post('node/auth/recuperar-senha-init', {email: username});
    }

    async changePassword(data) {
        return HttpRequest.post('node/auth/resetar-senha', data);
    }

    async getMe() {
        return HttpRequest.get('node/auth/me');
    }
}
